/*
 * @Description: 登录相关
 * @Author: 裴孚
 * @Date: 2022-11-15 10:27:02
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-04-17 16:05:00
 */
import JSEncrypt from 'jsencrypt'

// RSA公匙加密
export function getRSA (publicKey, value) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return encryptor.encrypt(value)
}

// 返回首页
export function backToHome () {
  window.location.href = '/'
}
// 返回登录页
export function backToLogin () {
  $cookies.remove('access_token')
  $cookies.remove('zddl')
  window.location.href = '/login'
}
